// extracted by css-extract-rspack-plugin
export default {"cls1":"FallbackBulkDownloadUpsellModalControl-cls1_2lV","cls2":"FallbackBulkDownloadUpsellModalControl-cls2_8lA FallbackBulkDownloadUpsellModalControl-cls1_2lV"};